import scrollToElement from "common/utils/ui/scroll";
import { on as onEvent } from "common/utils/ui/event";
import "./product-details-bulk-mobile.scss";

const BULK_MOBILE_SELECTOR = "#js-bulk-mobile";

const $getBulkMobile = () => document.querySelector(BULK_MOBILE_SELECTOR);
const $getBulkTable = () => document.getElementById("js-bulk-table-mobile");

const handleBulkMobileClick = ($bulkTable, $bulkMobile) => {
  if (!$bulkTable || !$bulkMobile) return;

  $bulkTable.classList.toggle("show");
  $bulkMobile.classList.toggle("opened");
  $bulkMobile.classList.toggle("product-details-bulk-mobile__bottom_margin");
};

const handlePricingParam = $bulkTable => {
  if (!$bulkTable) return;

  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get("t") === "pricing") {
    scrollToElement($bulkTable, true);
  }
};

const initBulkMobile = () => {
  const $bulkTable = $getBulkTable();
  const $bulkMobile = $getBulkMobile();

  onEvent("click", BULK_MOBILE_SELECTOR, () => {
    handleBulkMobileClick($bulkTable, $bulkMobile);
  });

  handlePricingParam($bulkTable);
};

export default initBulkMobile;
